import { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";
// import { useNavigate } from 'react-router-dom';
import { getProfile } from '../../services/userService';
import { storeSession, clearSession } from '../../utils/auth';
import useAuth from '../../hooks/useAuth';
// import { ERROR } from '../../routes';

function AuthEventHandler() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { id } = useAuth();
//   const navigate = useNavigate();

  const loadUserData = () => {
    getProfile()
      .then(data => storeSession(data))
      .catch(e => {
        console.error('User profile data ERROR: ', e);
        // navigate(ERROR, {state: {errorMessage: 'An error has occurred while loading user data!'}});
      })
  }

  useEffect(() => {
    const callbackId = instance.addEventCallback((message) => {
        if (message.eventType === EventType.LOGIN_SUCCESS) {
          loadUserData();
        }

        if (message.eventType === EventType.LOGOUT_SUCCESS) {
          clearSession();
        }

        // TODO - called twice
        if (message.eventType === EventType.HANDLE_REDIRECT_END) {
          if(!id && isAuthenticated) {
            loadUserData();
          }
        }
    });

    return () => {
      if (callbackId) {
          instance.removeEventCallback(callbackId);
      }
    }

  }, [id, isAuthenticated, instance, loadUserData]);

  return null;
}

export default AuthEventHandler;